declare global {
  interface Window {
    analytics: any;
  }
}

interface TrackPayload {
  event: string;
  properties: {
    category: string;
    label: string;
  };
}

const key = process.env.REACT_APP_SEGMENT_KEY;
const enabled = !!key && key !== 'off';

if (enabled) {
  window.analytics.load(key);
}

function call(fn: string, ...args: any[]) {
  if (enabled) {
    window.analytics[fn](...args);
  } else {
    console.debug(`[segment] ${fn} - ${JSON.stringify(args)}`);
  }
}

export function page(location?: string) {
  call('page', location);
}

export function login(userId: string, data?: any) {
  call('identify', userId, data);
}

export function logout() {
  call('reset');
}

export function track(payload: TrackPayload) {
  call('track', payload);
}
